
      var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExpandCircleRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 49,
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "expand-circle-right_158e3f26ca0368da__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 49
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1 0 0 1 48 .54)",
  fill: "var(--theme-light, #f9f3fb)",
  d: "M0 0h48v48H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#expand-circle-right_158e3f26ca0368da__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.8 24.54 5.45 5.45c.3.3.45.65.45 1.05s-.15.75-.45 1.05c-.3.3-.658.45-1.075.45-.417 0-.775-.15-1.075-.45l-6.5-6.5c-.3-.3-.45-.65-.45-1.05s.15-.75.45-1.05l6.55-6.55c.3-.3.65-.443 1.05-.426.4.017.75.175 1.05.475.3.3.45.65.45 1.05s-.15.75-.45 1.05l-5.45 5.45zm2.2 20c2.767 0 5.367-.526 7.8-1.576s4.55-2.483 6.35-4.3c1.8-1.817 3.225-3.942 4.275-6.375C43.475 29.856 44 27.272 44 24.54c0-2.767-.525-5.367-1.575-7.8-1.05-2.433-2.475-4.55-4.275-6.35-1.8-1.8-3.917-3.225-6.35-4.275-2.433-1.05-5.033-1.575-7.8-1.575-2.767 0-5.358.525-7.775 1.575-2.417 1.05-4.533 2.475-6.35 4.275-1.817 1.8-3.25 3.917-4.3 6.35C4.525 19.172 4 21.772 4 24.54c0 2.733.525 5.317 1.575 7.75 1.05 2.433 2.483 4.558 4.3 6.375a20.367 20.367 0 0 0 6.35 4.3c2.417 1.05 5.008 1.575 7.775 1.575zm0-3c-4.7 0-8.708-1.66-12.025-4.976C8.658 33.247 7 29.24 7 24.54c0-4.733 1.658-8.75 4.975-12.05C15.292 9.19 19.3 7.54 24 7.54c4.733 0 8.75 1.65 12.05 4.95 3.3 3.3 4.95 7.317 4.95 12.05 0 4.7-1.65 8.708-4.95 12.025-3.3 3.317-7.317 4.975-12.05 4.975z",
  fill: "var(--theme-primary, #810ea9)"
}))));

      const __svgRaw = "<svg width=\"48\" height=\"49\" viewBox=\"0 0 48 49\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <mask id=\"nll65itb9a\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"48\" height=\"49\">\r\n        <path transform=\"matrix(-1 0 0 1 48 .54)\" fill=\"var(--theme-light, #f9f3fb)\" d=\"M0 0h48v48H0z\"/>\r\n    </mask>\r\n    <g mask=\"url(#nll65itb9a)\">\r\n        <path d=\"m21.8 24.54 5.45 5.45c.3.3.45.65.45 1.05s-.15.75-.45 1.05c-.3.3-.658.45-1.075.45-.417 0-.775-.15-1.075-.45l-6.5-6.5c-.3-.3-.45-.65-.45-1.05s.15-.75.45-1.05l6.55-6.55c.3-.3.65-.443 1.05-.426.4.017.75.175 1.05.475.3.3.45.65.45 1.05s-.15.75-.45 1.05l-5.45 5.45zm2.2 20c2.767 0 5.367-.526 7.8-1.576s4.55-2.483 6.35-4.3c1.8-1.817 3.225-3.942 4.275-6.375C43.475 29.856 44 27.272 44 24.54c0-2.767-.525-5.367-1.575-7.8-1.05-2.433-2.475-4.55-4.275-6.35-1.8-1.8-3.917-3.225-6.35-4.275-2.433-1.05-5.033-1.575-7.8-1.575-2.767 0-5.358.525-7.775 1.575-2.417 1.05-4.533 2.475-6.35 4.275-1.817 1.8-3.25 3.917-4.3 6.35C4.525 19.172 4 21.772 4 24.54c0 2.733.525 5.317 1.575 7.75 1.05 2.433 2.483 4.558 4.3 6.375a20.367 20.367 0 0 0 6.35 4.3c2.417 1.05 5.008 1.575 7.775 1.575zm0-3c-4.7 0-8.708-1.66-12.025-4.976C8.658 33.247 7 29.24 7 24.54c0-4.733 1.658-8.75 4.975-12.05C15.292 9.19 19.3 7.54 24 7.54c4.733 0 8.75 1.65 12.05 4.95 3.3 3.3 4.95 7.317 4.95 12.05 0 4.7-1.65 8.708-4.95 12.025-3.3 3.317-7.317 4.975-12.05 4.975z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/expand-circle-right.158e3f26ca0368dafb0c28ee107c1a0d.svg"),
        {
          React: SvgExpandCircleRight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      